import { css } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
/**
  * Truncates a paragraph to the specified number of lines.
  * Will insert an ellipse (...) if the paragraph is truncated.
  * Tested on Chrome, Safari, iOS Safari, and iOS Chrome.
  * For non supporting browsers we would just not have truncation
  * which is OK because Chrome and Safari are our target browsers.
  *
  * Note: We have to set a max-height or else this method breaks in an
  * unusable way on messages that contain lists (<ul>) on
  * Safari and iOS Safari. The contained <ul> overlaps the text
  * that is shown.
  *
  * Example usage truncating to 2 lines:
  *  const Paragraph = styled(Text)`
  *    ...other styles...
  *    ${truncateLines({ lines: 2 })}
  *  `;
  */


var truncateLines = function truncateLines(_ref) {
  var lines = _ref.lines;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-clamp: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  max-height: 8em;\n"])), lines, lines);
};
/**
 * Companion utility to the above truncateLines functionality.
 * Given the DOM node where the truncation styles have been applied,
 * returns whether or not the the browser has applied truncation.
 *
 * We add +4 to clientHeight to account for browser pixel rounding.
 * I.e., if the text is truncated, we expect the scroll height to
 * contain at least 1 full line of text more than the client height
 * so we should see a large difference between the two heights.
 */


var isTruncated = function isTruncated(node) {
  return node && node.scrollHeight > node.clientHeight + 4;
};
/**
 * Converts a string to title case
 */


function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
/**
 * Converts a string to sentence case
 */


function toSentenceCase(str) {
  return str.replace(/\w\S*/g, function (txt, offset) {
    if (offset === 0) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    } else {
      return txt.toLowerCase();
    }
  });
}
/**
 * Converts a number to a formatted USD string.
 * Strips out trailing .00 if price is a whole number
 * otherwise returns USD price with 2 decimal points precision.
 */


function toUSDString(price) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$stripTrailing = _ref2.stripTrailing00,
      stripTrailing00 = _ref2$stripTrailing === void 0 ? true : _ref2$stripTrailing;

  if (price === null) {
    return '';
  } // This will round the price string to 2 decimal places.


  var formattedPrice = price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  }); // If the price ends with .00 then strip out the decimal
  // and only display the whole number price. Otherwise,
  // return the formatted price as is. If stripping trailing .00
  // is not desired then pass in false for stripTrailing00 option.

  return formattedPrice.endsWith('.00') && stripTrailing00 ? formattedPrice.split('.')[0] : formattedPrice;
}

export { isTruncated, toSentenceCase, toTitleCase, toUSDString, truncateLines };